import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * usePaicExecutionStore
 *
 * Talent Mobility's own "previous simulations" history for the PAIC Org
 * Redesign screen — distinct from Org Design's own `useOrgDesignStore`
 * versions (design history) since this records *execution* history (who was
 * marked available, what was exported) against an already-approved Org
 * Design snapshot.
 * Session-only by design — Talent Mobility data must not live in localStorage.
 */
const usePaicExecutionStore = create(
  devtools(
    (set) => ({
      // { resultId, versionId, versionLabel, savedAt, statusCounts }
      results: [],

      saveResult: (entry) => {
        const resultId = `paic-exec-${Date.now()}`;
        const record = { resultId, savedAt: Date.now(), ...entry };
        set((state) => ({ results: [record, ...state.results] }));
        return record;
      },
    }),
    { name: 'PaicExecutionStore' }
  )
);

// The store used to be persisted under this key — drop the stale entry so
// browsers that ran a simulation before the change don't keep dead data.
try {
  window.localStorage.removeItem('tm-paic-execution');
} catch {
  // storage unavailable (SSR/blocked) — nothing to clean up
}

export default usePaicExecutionStore;
